export default "__VITE_ASSET__CPsZmVj2__"